import styled from 'styled-components';

interface CropImageDivProps {
  loadingState?: string;
  mobileWidth?: number | string;
  width: number | string;
}

export const CropImageDiv = styled.div<CropImageDivProps>`
  width: ${({ width }) => (typeof width === 'string' ? width : `${width}px`)};

  @media (max-width: 480px) {
    width: ${({ mobileWidth }) =>
      mobileWidth
        ? typeof mobileWidth === 'string'
          ? mobileWidth
          : `${mobileWidth}px`
        : 'auto'};
  }
`;

interface StyledImageProps {
  loadingState?: string;
  mobileWidth?: number | string;
}

export const StyledImage = styled.img<StyledImageProps>`
  visibility: ${({ loadingState }) =>
    loadingState === 'loaded' ? 'visible' : 'hidden'};
  @media (max-width: 480px) {
    width: ${({ mobileWidth }) =>
      mobileWidth
        ? typeof mobileWidth === 'string'
          ? mobileWidth
          : `${mobileWidth}px`
        : 'auto'};
  }
`;
